import React, { ChangeEvent, Dispatch, SetStateAction } from 'react'

import { InlineMenu, Textarea } from '../../components'

import { QuestionWithAnswers } from './styles'

export const questions = [
  {
    id: '1',
    text: 'Por favor, indica cuáles han sido tus experiencias previas de trabajo vocal. (Profesores, técnicas o metodologías, duración, etc).',
    type: 'textarea',
  },
  {
    id: '2',
    text: 'Podrías resumir en algunas frases qué es lo que sientes que has obtenido como resultado de esos entrenamientos?',
    type: 'textarea',
  },
  {
    id: '3',
    text: '¿Hay algo que hayas alcanzado a descubrir pero no has llegado a entrenar, comprender en profundidad o asegurar?',
    type: 'textarea',
  },
  {
    id: '4',
    text: '¿Cuánto crees que conoces de tu instrumento vocal?',
    type: 'menu',
    menuName: 'knowInstrumentOptions',
  },
  {
    id: '5',
    text: '¿A que nivel de dominio/control vocal sientes que estas?',
    type: 'menu',
    menuName: 'experticeMenuStudent',
  },
  {
    id: '6',
    text: 'En la actualidad, ¿cuánto tiempo le dedicas al entrenamiento/desarrollo de tu Voz?',
    type: 'menu',
    menuName: 'dedicationTime',
  },
  {
    id: '7',
    text: '¿Cuanto tiempo estas dispuest@ a invertir en la repetición de ejercicios, pautas y tablas de entreno? (Trabajo en casa)',
    type: 'menu',
    menuName: 'dedicationTime',
  },
]

const QuestionsSection = ({
  formAnswers,
  setFormAnswers,
}: {
  formAnswers: Record<string, string>
  setFormAnswers: Dispatch<SetStateAction<Record<string, string>>>
}) => {
  const handleChangeAnswers = (number: string, value: string) => {
    setFormAnswers((prev) => ({ ...prev, [number]: value }))
  }

  return (
    <>
      {questions.map(({ id, text, type, menuName }) => (
        <QuestionWithAnswers key={id}>
          <p className="number">{id}</p>
          <p className="question">{text}</p>
          <div className="textarea-answer">
            {type === 'textarea' ? (
              <Textarea
                id={`question-${id}`}
                name={id}
                value={formAnswers[id] || ''}
                height={70}
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                  handleChangeAnswers(id, event.target.value)
                }
              />
            ) : (
              <InlineMenu
                userType="student"
                menuName={menuName || ''}
                activeFilter={formAnswers[id] || null}
                setActiveFilter={(value) =>
                  handleChangeAnswers(id, value as string)
                }
                isDisabled={false}
              />
            )}
          </div>
        </QuestionWithAnswers>
      ))}
    </>
  )
}

export default QuestionsSection
